import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "001_initial",
  version: "1.0.0",
  sql: `
CREATE TABLE IF NOT EXISTS \`chat_settings\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`default_system_prompt\` text,
	\`handoff_message\` text DEFAULT 'กำลังโอนสายให้พนักงาน กรุณารอสักครู่ครับ' NOT NULL,
	\`welcome_message\` text DEFAULT 'สวัสดีครับ! ยินดีต้อนรับสู่ระบบเช่ารถ มีอะไรให้ช่วยไหมครับ?' NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text
);
CREATE UNIQUE INDEX IF NOT EXISTS \`chat_settings_company_id_unique\` ON \`chat_settings\` (\`company_id\`);
CREATE TABLE IF NOT EXISTS \`chat_facebook_pages\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`page_id\` text NOT NULL,
	\`page_name\` text NOT NULL,
	\`access_token\` text NOT NULL,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`webhook_verify_token\` text NOT NULL,
	\`default_ai_agent_id\` text,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text
);
CREATE TABLE IF NOT EXISTS \`chat_conversations\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`facebook_page_id\` text NOT NULL,
	\`sender_psid\` text NOT NULL,
	\`sender_name\` text,
	\`sender_avatar\` text,
	\`status\` text DEFAULT 'bot' NOT NULL,
	\`assigned_to\` text,
	\`last_message_at\` text,
	\`last_message_preview\` text,
	\`unread_count\` integer DEFAULT 0 NOT NULL,
	\`ai_agent_id\` text,
	\`metadata\` text,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`facebook_page_id\`) REFERENCES \`chat_facebook_pages\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`chat_conversations_company_status_idx\` ON \`chat_conversations\` (\`company_id\`, \`status\`);
CREATE INDEX IF NOT EXISTS \`chat_conversations_facebook_page_id_idx\` ON \`chat_conversations\` (\`facebook_page_id\`);
CREATE TABLE IF NOT EXISTS \`chat_messages\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`conversation_id\` text NOT NULL,
	\`direction\` text NOT NULL,
	\`sender_type\` text NOT NULL,
	\`content\` text NOT NULL,
	\`message_type\` text DEFAULT 'text' NOT NULL,
	\`fb_message_id\` text,
	\`metadata\` text,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`conversation_id\`) REFERENCES \`chat_conversations\`(\`id\`) ON UPDATE no action ON DELETE no action
);
  `.trim(),
};
